/**
 * AuthService -- Orchestrates authentication flow.
 * Validates session on startup, handles login/logout.
 *
 * @module application/AuthService
 */

import { AppConfig } from '../config.js';
import { AuthApiClient } from '../infrastructure/api/AuthApiClient.js';
import { EventBus } from '../shared/EventBus.js';
import { EVENTS } from '../shared/constants.js';

export const AuthService = {
  async login(email, password) {
    const result = await AuthApiClient.login(email, password);
    if (result.ok) {
      const d = result.data?.data || result.data || {};
      const token = d.token;
      AppConfig.login(token, AppConfig.env);

      // El rol de la API se guarda SIEMPRE, tambien cuando es 'dev'. Antes se
      // omitia ese caso, y desde que el rol por defecto es 'member' (CTX-M2-09)
      // omitirlo dejaria a un dev de verdad con permisos de member.
      const role = d.role;
      if (role) {
        AppConfig.setRole(role);
      }

      // Lock business if API returns businessId
      const bizId = d.businessId;
      if (bizId) {
        localStorage.setItem('nx_selected_business', bizId);
        localStorage.setItem('nx_selected_business_name', d.usuario || '');
        localStorage.setItem('nx_business_locked', 'true');
      }

      EventBus.emit(EVENTS.AUTH_LOGIN, { email });
    }
    return result;
  },

  logout() {
    AppConfig.logout();
    localStorage.removeItem('nx_business_locked');
    sessionStorage.removeItem('nx_operador_id');
    sessionStorage.removeItem('nx_operador_nombre');
    sessionStorage.removeItem('nx_operador_cargo');
    EventBus.emit(EVENTS.AUTH_LOGOUT);
  },

  async validateSession() {
    if (!AppConfig.isAuthenticated) return false;
    const result = await AuthApiClient.validate();
    if (!result.ok) {
      AppConfig.logout();
      return false;
    }
    return true;
  },

  get isAuthenticated() {
    return AppConfig.isAuthenticated;
  },

  get currentEnv() {
    return AppConfig.env;
  }
};
